<template>
  <div class="contractors-actions">
    <div class="search">
      <tol-type-ahead
        :search-params="{
          url: '/contractors/list',
          searchKeys: ['searchParam'],
          urlParams: {
            recordsPerPage: contractorsPerPage,
            offset: contractorsListingOffset,
            sortBy: contractorsSortBy,
            sortDirection: contractorsSortDirection,
            activeInactive: contractorsActiveInactive
          }
        }"
        :allow-empty-search="true"
        :results-in-dropdown="false"
        @filtered="onFiltered($event)"
      >
      </tol-type-ahead>
    </div>
    <div class="right">
      <router-link to="/contractors/create">
        <TolAltButton icon-name="plus" label="New contractor" />
      </router-link>
      <TolAltButton icon-name="file-excel" label="Export to Excel" @click="exportAsExcel" />
    </div>
  </div>
</template>

<script>
import TolAltButton from '@/app/components/TolAltButton';
import TolTypeAhead from '@/app/components/TolTypeAhead';
import {
  ContractorsListingActions,
  ContractorsListingGetters
} from '@/app/features/contractors/features/contractors-listing/contractors-listing.keys';

export default {
  name: 'ContractorsActions',
  components: {
    TolTypeAhead,
    TolAltButton
  },
  computed: {
    contractorsPerPage() {
      return this.$store.getters[ContractorsListingGetters.ContractorsPerPage];
    },
    contractorsListingOffset() {
      return this.$store.getters[ContractorsListingGetters.ContractorsListingOffset];
    },
    contractorsSortBy() {
      return this.$store.getters[ContractorsListingGetters.SortBy];
    },
    contractorsSortDirection() {
      return this.$store.getters[ContractorsListingGetters.SortDirection];
    },
    contractorsActiveInactive() {
      return this.$store.getters[ContractorsListingGetters.ContractorsActiveInactive];
    }
  },
  message: {
    get() {
      switch (this.selectedBulkAction) {
        case 'PDF':
          return this.$t('bulk.actions.saveAsPdf');
        default:
          return '';
      }
    }
  },
  methods: {
    exportAsExcel() {
      this.$store.dispatch(ContractorsListingActions.ExportContractorsAsExcel);
    },
    onFiltered(results) {
      this.$store.dispatch(ContractorsListingActions.UpdateContractorsList, results);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.contractors-actions {
  display: flex;
  background-color: $background-level-2;
  padding: 60px;

  .search {
    margin-left: auto;
    display: block;
    flex-basis: 50%;
  }

  .right {
    margin-left: auto;
    display: flex;
    flex-basis: 25%;
    justify-content: flex-end;
    a {
      text-decoration: none;
      color: inherit;
    }
    .wrapper {
      padding-left: 10px;
    }
  }
}
</style>
